// extracted by mini-css-extract-plugin
export default {"wrapper":"AddProjectForm_wrapper__4cvrY","controlWrapper":"AddProjectForm_controlWrapper__vV+HM"};